<script lang="ts" setup>
import { useActiveOrganization } from 'auth-package'
import Organizations from '@/components/settings/Organizations.vue'
import EditActiveOrganization from '@/components/settings/EditActiveOrganization.vue'

const activeOrganization = useActiveOrganization()
</script>

<template>
    <h1>{{ $t('settings.editOrganization', { name: activeOrganization?.name }) }}</h1>
    <EditActiveOrganization />

    <prizific-title-description :title="$t('settings.myOrganizations')" titleBold marginBottom="4" marginTop="5" />
    <Organizations />
</template>

<style lang="scss" scoped></style>
